
import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  // const navigate = useNavigate();
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

    useEffect(() => {
    // Set the launch date 30 days from now
    const launchDate = new Date();
    launchDate.setDate(launchDate.getDate() + 33);

    const timer = setInterval(() => {
      const now = new Date();
      const difference = launchDate - now;

      if (difference <= 0) {
        clearInterval(timer);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      } else {
        const days = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((difference / (1000 * 60)) % 60);
        const seconds = Math.floor((difference / 1000) % 60);

        setTimeLeft({ days, hours, minutes, seconds });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="landing-container">
      {/* <button className="enter-button" onClick={() => navigate('/home2')}>
        Enter
      </button> */}
      <div className="landing-content">
        <h1>Welcome to PhumulaniNtuliStudio</h1>
        {/* Add a count down here */}
          <div class="countdown">
            <div class="countdown-item">
                <div class="countdown-number" id="days">{timeLeft.days}</div>
                <div class="countdown-label">Days</div>
            </div>
            <div class="countdown-item">
                <div class="countdown-number" id="hours">{timeLeft.hours}</div>
                <div class="countdown-label">Hours</div>
            </div>
            <div class="countdown-item">
                <div class="countdown-number" id="minutes">{timeLeft.minutes}</div>
                <div class="countdown-label">Minutes</div>
            </div>
            <div class="countdown-item">
                <div class="countdown-number" id="seconds">{timeLeft.seconds}</div>
                <div class="countdown-label">Seconds</div>
            </div>
        </div>
        {/* <div className="countdown">
          <h2>Launching in:</h2>
          <span>{timeLeft.days}d</span>
          <span>{timeLeft.hours}h</span>
          <span>{timeLeft.minutes}m</span>
          <span>{timeLeft.seconds}s</span>
        </div> */}
        <p>&copy; 2024 PhumulaniNtuliStudio. All rights reserved.</p>
      </div>
    </div>
  );
};

export default LandingPage;
